<template>
  <div class='container container-btn-footer container-nav'>
    <van-nav-bar
      title="新增"
      left-arrow
      @click-left="goBack()"
      :fixed="true"
    />
    <div class="add">
      <div class="content-box">
        <van-field
          class="content"
          v-model="content"
          required
          autosize
          label="养旺记忆"
          type="textarea"
          rows="4"
          maxlength="140"
          placeholder="养旺帮您记录您的健康记忆"
          show-word-limit
        />
      </div>
      <div class="img-list">
        <image-upload width="20vw" :draftId="draft_id" delUrl="/api/http/feed/remove/image" uploadUrl="/api/http/feed/upload/image" :maxCount="6" @success="imageUpload" />
      </div>
      <div>
        <van-field name="switch" label="上传病例" input-align="right">
          <template #input>
            <van-switch v-model="switchChecked" size="20" />
          </template>
        </van-field>
        <div class="switch-img" v-show="switchChecked">
          <image-upload width="20vw" :draftId="draft_id" delUrl="/api/http/feed/remove/case" :disabled="!switchChecked" uploadUrl="/api/http/feed/upload/case" :maxCount="3" @success="caseUpload" />
        </div>
      </div>
      <div class="ml16">
        <p class="f16 c-999">其他资料({{otherList.length}}/3)</p>
        <div class="file-list">
          <div class="file-item" v-for="(item, index) in otherList" :key="index">
            <div class="icon">
              <van-icon name="description-o" />
            </div>
            <div class="detail">
              <p class="name">{{item.origin_name}}</p>
              <p class="desc"><span>{{item.size | FileSize}}</span><span class="type txt-elips">{{item.mime_type}}</span></p>
            </div>
            <div>
              <van-popover
                v-model="item.showPop"
                theme="dark"
                placement="left"
                trigger="click"
                :actions="actions(item)"
                @select="deleteFile(item, index, 'other')"
              >
                <template #reference>
                  <van-icon name="ellipsis" style="transform: rotate(90deg)" size="20" />
                </template>
              </van-popover>
            </div>
          </div>
        </div>
        <div class="update-input-box" @click="ClickBox" v-show="otherList.length < 3">
          <div class="update">
            <van-icon name="plus" color="#ccc" />
          </div>
          <input ref="updateFile" :disabled="isLoading" class="update-input" type="file" name="file" @change="updateFile">
        </div>
      </div>
    </div>
    <div class="button">
      <button type="info" @click="save">保存</button>
    </div>
  </div>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
import { uploadFile } from '@/api/retry';
export default {
  name: 'ywq-add',
  components: {
    ImageUpload
  },
  data() {
    return {
      show: false,
      // eslint-disable-next-line
      draft_id: '',
      content: '',
      imgList: [],
      switchChecked: false,
      caseList: [],
      otherList: [],
      isLoading: false
    };
  },
  filters: {
    FileSize: function (value) {
      if (!value) {
        return '0 Bytes';
      }
      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      let i = 0;
      while (value >= 1024) {
        value /= 1024;
        i++;
      }
      return value.toFixed(2) + ' ' + units[i];
    }
  },
  computed: {
    // todo
  },
  beforeMount() {
    this.createId();
  },
  mounted() {
    // todo
  },
  watch: {},
  methods: {
    actions(item) {
      return [{ text: '删除' }];
    },
    imageUpload(urls) {
      this.imgList = urls;
    },
    ClickBox() {
      this.$refs.updateFile.click();
    },
    caseUpload(urls) {
      this.caseList = urls;
    },
    async createId() {
      try {
        const res = await this.$store.dispatch('postData', {
          url: '/api/http/feed/draft'
        });
        // eslint-disable-next-line
        this.draft_id = res.draft_id;
      } catch (error) {
        this.ToastUni(error.message);
      }
    },
    async save() {
      try {
        if (!this.content.trim()) {
          this.ToastUni('请输入养旺记忆');
          return;
        }
        this.Loading(`正在保存...`);
        await this.$store.dispatch('postData', {
          url: '/api/http/feed/create',
          data: {
            // eslint-disable-next-line
            draft_id: this.draft_id,
            content: this.content,
            files: this.imgList.map(img => img.data_encrypt),
            cases: !this.switchChecked ? [] : this.caseList.map(img => img.data_encrypt),
            other: this.otherList.map(img => img.data_encrypt)
          }
        });
        window.upDateDetail = {
          type: 'add'
        };
        this.ToastUni('保存成功');
        this.laterGoBack();
      } catch (error) {
        this.ToastClear();
        this.ToastUni(error.message);
      }
    },
    async updateFile(event) {
      try {
        const files = event.target.files;
        if (files && files.length) {
          const file = files[0];
          const name = file.name;
          // const fileType = file.type;
          const fileSize = file.size; // 获取文件大小（字节）
          const maxSize = 10485760; // 最大文件大小限制为10MB（10 * 1024 * 1024字节）
          if (fileSize > maxSize) {
            this.ToastUni('文件大小不能超过10MB！');
            return;
          }
          if (name.length > 200) {
            this.ToastUni('文件名不得超过200字符！');
            return;
          }
          const formData = new FormData();
          formData.append('draft_id', this.draft_id);
          formData.append('media_file', file);
          this.Loading(`正在上传...`);
          const res = await uploadFile(formData, '/api/http/feed/upload/other');
          const item = res.data;
          item.showPop = false;
          this.otherList.push(item);
          this.ToastClear();
        }
      } catch (error) {
        this.ToastClear();
        console.log(error);
        this.ToastUni('上传失败:' + error.message);
      }
    },
    deleteFile(item, index, url) {
      this.otherList.splice(index, 1);
    }
    // async deleteFile(item, index, url) {
    //   try {
    //     this.Loading();
    //     await this.$store.dispatch('postData', {
    //       url: '/api/http/feed/remove/' + url,
    //       data: {
    //         // eslint-disable-next-line
    //         data_encrypt: item.data_encrypt,
    //         // eslint-disable-next-line
    //         draft_id: this.draft_id
    //       }
    //     });
    //     this.otherList.splice(index, 1);
    //     this.ToastClear();
    //   } catch (error) {
    //     this.ToastClear();
    //     this.ToastUni(error.message);
    //   }
    // }
  }
};
</script>
<style lang='less' scoped>
.add{
  padding: 20px;
  background-color: #fff;
  /deep/ .van-field__label{
    font-weight: 800;
  }
}
.content-box{
  position: relative;
}
.content-box::after{
  content: '';
  position: absolute;
  bottom: 2px;
  left: 16px;
  width: calc(100% - 32px);
  height: 2px;
  background-color: #eee;
}
.content{
  position: relative;
  display: flex;
  flex-direction: column;
  /deep/ .van-field__word-limit{
    position: absolute;
    top: -24px;
    right: 0;
  }
}
.img-list{
  position: relative;
  padding: 16px;
}
.switch-img{
  position: relative;
  padding: 16px;
}
.switch-img::after{
  content: '';
  position: absolute;
  top: 2px;
  left: 16px;
  width: calc(100% - 32px);
  height: 2px;
  background-color: #eee;
}
.file-list{
  padding: 10px 0;
  .file-item{
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    .icon{
      width: 45px;
      height: 45px;
      color: #fff;
      background-color: #E7C188;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .detail{
      height: 45px;
      width: calc(100% - 75px);
      padding: 5px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;
      .name{
        font-size: 14px;
        font-weight: 600;
      }
      .desc{
        color: #999;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        .type{
          max-width: calc(100vw - 200px);
        }
      }
    }
  }
}
.update-input-box{
  position: relative;
  width: 45px;
  height: 45px;
  .update{
    position: relative;
    z-index: 10;
    width: 45px;
    height: 45px;
    background-color: #f7f8fa;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .update-input{
    display: none;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 45px;
    height: 45px;
  }
}
.button{
  position: fixed;
  z-index: 100;
  bottom: 0;
  width: 100%;
  height: 64px;
  padding: 10px 40px;
  box-sizing: border-box;
  button{
    width: 100%;
    height: 40px;
    font-size: 14px;
    border: 0;
    border-radius: 5px;
    color: #fff;
    background-color: #0076F6;
  }
}
</style>
